var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import linker from '../linker';
import showError from '../central/showError';
import { CategoryNaviItem } from './molecules';
import { DropPop, GridLayout } from './atoms';
import { PageService } from '../services/PageService';
import { AssistantService } from '../services/AssistantService';
import { TermNaviService } from '../services/TermNaviService';
import { BaseService } from '../services/BaseService';
var CategoryPageNavi = (function (_super) {
    __extends(CategoryPageNavi, _super);
    function CategoryPageNavi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.termPath = [];
        _this.termNotFound = false;
        _this.parentCategory = null;
        _this.category = null;
        _this.pagesLoaded = false;
        _this.pages = [];
        _this.contentClass = 'rsp2Grid';
        _this.assistants = [];
        _this.assistantsLoaded = false;
        _this.sortByItems = BaseService.getDropPopItems().concat();
        _this.sort = _this.sortByItems.find(function (item) { return item.selected; }).value;
        return _this;
    }
    CategoryPageNavi.prototype.mounted = function () {
        this.load();
    };
    CategoryPageNavi.prototype.load = function () {
        var _this = this;
        var _a;
        if (SP.Guid.isValid(this.termSetId)) {
            var srv = TermNaviService.start(this.termSetId);
            this.termPath.splice(0);
            (_a = this.termPath).push.apply(_a, srv.getCurrentTermPath());
            srv.loadTermItem(this.termPath).then(function (term) {
                if (term) {
                    _this.category = term;
                    new PageService().loadPages(_this.category.id, _this.sort).then(function (pages) {
                        _this.pages = pages;
                        _this.pagesLoaded = true;
                    });
                    new AssistantService().loadAssistants(_this.category.id, _this.sort).then(function (assistants) {
                        _this.assistants = assistants;
                        _this.assistantsLoaded = true;
                    });
                }
                else {
                    _this.termNotFound = true;
                    if (_this.notFoundUrl) {
                        window.location.href = _this.notFoundUrl;
                    }
                }
            });
            srv.loadTermItem(this.termPath.slice(0, this.termPath.length - 1)).then(function (term) {
                _this.parentCategory = term;
            });
        }
        else {
            showError('CategoryNaviTermSetId in Portalkonfiguration ist nicht gesetzt!');
        }
    };
    CategoryPageNavi.prototype.setSort = function (sort) {
        var _this = this;
        this.sort = sort;
        new PageService().loadPages(this.category.id, this.sort).then(function (pages) {
            _this.pages = pages;
        });
        new AssistantService().loadAssistants(this.category.id, this.sort).then(function (assistants) {
            _this.assistants = assistants;
        });
    };
    __decorate([
        Prop({ type: String })
    ], CategoryPageNavi.prototype, "termSetId", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryPageNavi.prototype, "notFoundUrl", void 0);
    CategoryPageNavi = __decorate([
        Component({
            components: {
                GridLayout: GridLayout,
                DropPop: DropPop,
                CategoryNaviItem: CategoryNaviItem,
            },
        })
    ], CategoryPageNavi);
    return CategoryPageNavi;
}(Vue));
export default CategoryPageNavi;
linker.register('categoryPageNavi', CategoryPageNavi);
